import { SubmissionCard, Text } from 'shell/components';
import { DRAFT_TYPES } from 'utils/constants';

const feedback = {
    created_on: 1698821880000,
};

const assignment = {
    end_on: 1698906600000,
};

const submission = {
    created_on: 1698821880000,
};

const SubmissionCardDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>SubmissionCard</Text>
            <SubmissionCard
                draftNum={1}
                feedback={null}
                variant={DRAFT_TYPES.DRAFT}
                onClickSubmit={console.log}
                onClickViewSubmission={console.log}
            />
            <SubmissionCard
                draftNum={1}
                feedback={feedback}
                variant={DRAFT_TYPES.DRAFT}
                onClickSubmit={console.log}
                onClickViewSubmission={console.log}
            />
            <SubmissionCard
                assignment={assignment}
                submission={null}
                variant={DRAFT_TYPES.FINAL_DRAFT}
                onClickSubmit={console.log}
                onClickViewSubmission={console.log}
                onClickResubmit={console.log}
            />
            <SubmissionCard
                assignment={assignment}
                submission={submission}
                variant={DRAFT_TYPES.FINAL_DRAFT}
                onClickSubmit={console.log}
                onClickViewSubmission={console.log}
                onClickResubmit={console.log}
            />
        </>
    );
};

export default SubmissionCardDemo;
